import React from "react";
import styles from "./styles.module.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

import BlueButton from "../BlueButton";
import WhiteButton from "../WhiteButton";

export const ConfirmDialog = ({
  open,
  onClose,
  onClickSim,
  text,
  title,
  confirmLabel = "Sim",
  confirmVariant = "primary",
  showWarningIcon = true,
  loading = false,
}) => {
  const isError = confirmVariant === "error";
  const handleConfirm = () => {
    if (loading) return;
    onClickSim?.();
  };
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} PaperProps={{ sx: { borderRadius: 2, minWidth: 320 } }}>
      {title && (
        <DialogTitle sx={{ fontWeight: 600, color: "#0d2847", pb: 0 }}>
          {title}
        </DialogTitle>
      )}
      <DialogContent sx={{ pt: title ? 1.5 : 2 }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, textAlign: title ? "left" : "center" }}>
          {showWarningIcon && !title && (
            <WarningIcon sx={{ color: "#ff9800", fontSize: 28, flexShrink: 0 }} />
          )}
          <Typography component="span" sx={{ color: "#0d2847", fontSize: "1rem", lineHeight: 1.5 }}>
            {text}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 0, justifyContent: "flex-end", gap: 1 }}>
        <WhiteButton clickFunction={onClose} textValue="Cancelar" />
        {isError ? (
          <Button
            variant="contained"
            onClick={handleConfirm}
            disabled={loading}
            sx={{
              bgcolor: "#c62828",
              color: "#fff",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              minWidth: 100,
              "&:hover": { bgcolor: "#b71c1c" },
              "&:disabled": { bgcolor: "#b71c1c", color: "#fff" },
            }}
          >
            {loading ? <CircularProgress size={22} color="inherit" /> : confirmLabel}
          </Button>
        ) : (
          <BlueButton
            clickFunction={handleConfirm}
            textValue={loading ? "Enviando e-mail..." : confirmLabel}
            disabled={loading}
            contentStartIcon={loading ? <CircularProgress size={18} sx={{ color: "#fff", mr: 0.5 }} /> : null}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};
